var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "planning-form" } },
    [
      _c(
        "Titlebar",
        {
          attrs: {
            incrustation: "fa-calendar",
            backPath: "/parameters/planning",
          },
        },
        [_c("h1", { domProps: { innerHTML: _vm._s(_vm.pageTitle) } })]
      ),
      _vm._v(" "),
      _c("LoadingMini", { ref: "loading" }),
      _vm._v(" "),
      _vm.planning
        ? _c("div", { staticClass: "row justify-content-center" }, [
            _c(
              "div",
              { staticClass: "col-4 col-xl-4" },
              [
                _c("UiCard", [
                  _c("form", { staticClass: "form p-0" }, [
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("planning.form.label"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-8" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.planning.label,
                              expression: "planning.label",
                            },
                            { name: "validate", rawName: "v-validate" },
                          ],
                          staticClass: "form-input w-100",
                          attrs: {
                            type: "text",
                            name: "label",
                            "data-vv-rules": "required",
                            "data-vv-as": _vm.$t("planning.form.label"),
                          },
                          domProps: { value: _vm.planning.label },
                          on: {
                            change: function ($event) {
                              return _vm.modification()
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.planning,
                                "label",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.showErrors["label"] &&
                                  _vm.errors.has("label"),
                                expression:
                                  "showErrors['label'] && errors.has('label')",
                              },
                            ],
                            staticClass: "form-input-error",
                            on: {
                              click: function ($event) {
                                return _vm.hideError("label")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.errors.first("label")))]
                        ),
                        _vm._v(" "),
                        _c("small", { staticClass: "form-text text-muted" }, [
                          _vm._v(_vm._s(_vm.$t("planning.form.labelHelp"))),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("planning.form.profile"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-8" },
                        [
                          _c("multiselect", {
                            staticClass: "from-top",
                            attrs: {
                              id: "planningProfiles",
                              multiple: true,
                              "close-on-select": true,
                              taggable: false,
                              placeholder: "",
                              options: _vm.profiles,
                              label: "label",
                              name: "profiles",
                              "track-by": "profileId",
                              loading: _vm.profilesLoading,
                            },
                            on: {
                              blur: _vm.modification,
                              tag: _vm.modification,
                              select: _vm.modification,
                              remove: _vm.modification,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "option",
                                  fn: function (ref) {
                                    var option = ref.option
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          option.meta.icon
                                            ? _c("ProfileIcon", {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  icon: option.meta.icon,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-truncate" },
                                            [_vm._v(_vm._s(option.label))]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "tag",
                                  fn: function (ref) {
                                    var option = ref.option
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          option.meta.icon
                                            ? _c("ProfileIcon", {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  icon: option.meta.icon,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-truncate" },
                                            [_vm._v(_vm._s(option.label))]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              193149400
                            ),
                            model: {
                              value: _vm.planningProfiles,
                              callback: function ($$v) {
                                _vm.planningProfiles = $$v
                              },
                              expression: "planningProfiles",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.showErrors["profiles"] &&
                                    _vm.errors.has("label"),
                                  expression:
                                    "showErrors['profiles'] && errors.has('label')",
                                },
                              ],
                              staticClass: "form-input-error",
                              on: {
                                click: function ($event) {
                                  return _vm.hideError("label")
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.errors.first("label")))]
                          ),
                          _vm._v(" "),
                          _c("small", { staticClass: "form-text text-muted" }, [
                            _vm._v(_vm._s(_vm.$t("planning.form.profileHelp"))),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("planning.form.group"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-8" },
                        [
                          _c("multiselect", {
                            staticClass: "from-top",
                            attrs: {
                              id: "planningGroups",
                              multiple: true,
                              "close-on-select": true,
                              taggable: false,
                              placeholder: "",
                              options: _vm.groups,
                              label: "label",
                              name: "groups",
                              "track-by": "id",
                              loading: _vm.groupsLoading,
                            },
                            on: {
                              blur: _vm.modification,
                              tag: _vm.modification,
                              select: _vm.modification,
                              remove: _vm.modification,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "option",
                                  fn: function (ref) {
                                    var option = ref.option
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(option.label)),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "tag",
                                  fn: function (ref) {
                                    var option = ref.option
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(option.label)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              613307416
                            ),
                            model: {
                              value: _vm.planningGroups,
                              callback: function ($$v) {
                                _vm.planningGroups = $$v
                              },
                              expression: "planningGroups",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.showErrors["groups"] &&
                                    _vm.errors.has("label"),
                                  expression:
                                    "showErrors['groups'] && errors.has('label')",
                                },
                              ],
                              staticClass: "form-input-error",
                              on: {
                                click: function ($event) {
                                  return _vm.hideError("label")
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.errors.first("label")))]
                          ),
                          _vm._v(" "),
                          _c("small", { staticClass: "form-text text-muted" }, [
                            _vm._v(_vm._s(_vm.$t("planning.form.groupHelp"))),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("planning.form.dati"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-8" },
                        [
                          _c("multiselect", {
                            staticClass: "from-top",
                            attrs: {
                              id: "planningDatis",
                              multiple: true,
                              "close-on-select": true,
                              taggable: false,
                              placeholder: "",
                              options: _vm.datis,
                              label: "label",
                              name: "datis",
                              "track-by": "id",
                              loading: _vm.datisLoading,
                            },
                            on: {
                              blur: _vm.modification,
                              tag: _vm.modification,
                              select: _vm.modification,
                              remove: _vm.modification,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "option",
                                  fn: function (ref) {
                                    var option = ref.option
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(option.label)),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "tag",
                                  fn: function (ref) {
                                    var option = ref.option
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "tag-content" },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                option.label || option.name
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      option.from
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "tooltip bottom",
                                                staticStyle: {
                                                  width: "140px",
                                                  bottom: "calc(100% + 5px)",
                                                  right: "calc(50% - 14px)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      option.fromObject.name ||
                                                        option.fromObject.label
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1973709743
                            ),
                            model: {
                              value: _vm.planningDatis,
                              callback: function ($$v) {
                                _vm.planningDatis = $$v
                              },
                              expression: "planningDatis",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.showErrors["datis"] &&
                                    _vm.errors.has("label"),
                                  expression:
                                    "showErrors['datis'] && errors.has('label')",
                                },
                              ],
                              staticClass: "form-input-error",
                              on: {
                                click: function ($event) {
                                  return _vm.hideError("label")
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.errors.first("label")))]
                          ),
                          _vm._v(" "),
                          _c("small", { staticClass: "form-text text-muted" }, [
                            _vm._v(_vm._s(_vm.$t("planning.form.datiHelp"))),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("planning.form.active"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-8 col-xl-6" },
                        [
                          _c("UiSwitch", {
                            attrs: { trueValue: 1, falseValue: 0 },
                            on: {
                              input: function () {
                                return (_vm.hasModifications = true)
                              },
                            },
                            model: {
                              value: _vm.planning.active,
                              callback: function ($$v) {
                                _vm.$set(_vm.planning, "active", $$v)
                              },
                              expression: "planning.active",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "small",
                        { staticClass: "col-8 offset-4 form-text text-muted" },
                        [_vm._v(_vm._s(_vm.$t("planning.form.activeHelp")))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-row row planning-description" },
                      [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("planning.form.notificationHelp"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-row row" },
                      [
                        _c("NotificationPhonePreview", {
                          attrs: {
                            title: _vm.notificationPreview.title,
                            description: _vm.notificationPreview.content,
                            display: "small",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-8 col-xl-8" },
              [
                _c(
                  "UiCard",
                  { staticClass: "full-height" },
                  [
                    _c("Calendar", {
                      ref: "calendar",
                      staticClass: "full-height",
                      attrs: { config: _vm.config },
                      on: {
                        select: _vm.timeSelect,
                        eventDrop: _vm.eventDrop,
                        eventResize: _vm.eventResize,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Toolbar",
        [
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-edit-profiles",
                  expression: "'beepiz-edit-profiles'",
                },
              ],
              class: ["primary pull-right", { disabled: !_vm.formIsValidable }],
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.validForm()
                },
              },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("global.save")) + "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "profiles.profiles.edit",
                  expression: "'profiles.profiles.edit'",
                },
              ],
              class: "pull-right",
            },
            [
              _c(
                "router-link",
                { attrs: { to: "/parameters/planning", tag: "span" } },
                [_vm._v(_vm._s(_vm.$t("global.cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }